/**
 * Hamburger Menu
 *
 * @param {string} menu
 * @param {string} hamburger
 * @returns {void}
 */
const hamburgerMenu = (menu, hamburger) => {
    const $body = $('body');
    const $window = $(window);
    const $menu = $(menu);
    const $button = $(hamburger);
    const $all = $button.add($menu);

    $button.on('click', () => {
        $all.toggleClass('is-active');
        $body.toggleClass('is-overflow');
    });

    $window.on('click', (e) => {
        if (!$(e.target).closest($all).length) {
            $all.removeClass('is-active');
            $body.removeClass('is-overflow');
        }
    });

    $window.resize(() => {
        if ($window.width() > 992 && !$menu.hasClass('is-active')) {
            $all.removeClass('is-active');
            $body.removeClass('is-overflow');
        }
    });
};

export default hamburgerMenu;
